import React from "react";
import { useIntl } from "react-intl";

import { RichText } from "@learningblocks/shared-components/lib/RichText";

import { TableCellProps, CellAlignment } from "../types";
import {
  fixedCellClass,
  fixedCellZebraClass,
  fixedCellCenterClass,
  fixedCellCenterZebraClass,
  fixedCellRightClass,
  fixedCellRightZebraClass,
} from "../TableQuestion.css";

export interface FixedCellProps extends Pick<
  TableCellProps,
  "cellId" | "text" | "colspan" | "ariaLabel"
> {
  align?: CellAlignment;
  isZebra?: boolean;
  bgColor?: string;
}

const ALIGNMENT_CLASSES: Record<
  CellAlignment,
  { normal: string; zebra: string }
> = {
  left: { normal: fixedCellClass, zebra: fixedCellZebraClass },
  center: { normal: fixedCellCenterClass, zebra: fixedCellCenterZebraClass },
  right: { normal: fixedCellRightClass, zebra: fixedCellRightZebraClass },
};

const getCellClass = (align?: CellAlignment, isZebra?: boolean): string => {
  const classes = ALIGNMENT_CLASSES[align ?? "left"];
  return isZebra ? classes.zebra : classes.normal;
};

export const FixedCell: React.FC<FixedCellProps> = ({
  cellId,
  text,
  colspan,
  align,
  isZebra,
  bgColor,
  ariaLabel,
}) => {
  const intl = useIntl();

  const translatedText = text
    ? intl.formatMessage({ id: text, defaultMessage: text })
    : "";

  const translatedAriaLabel = ariaLabel
    ? intl.formatMessage({ id: ariaLabel, defaultMessage: ariaLabel })
    : undefined;

  const style = {
    ...(bgColor && { backgroundColor: bgColor }),
  };

  return (
    <td
      key={cellId}
      className={getCellClass(align, isZebra)}
      colSpan={colspan ? Number(colspan) : undefined}
      style={style}
      aria-label={translatedAriaLabel}
    >
      <RichText value={translatedText} />
    </td>
  );
};
